export default __webpack_public_path__ + "static/media/q6.cef96e76.png";